function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScImage = function SvgScImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M3 17.4L5.53279 14.6139C5.92955 14.1775 6.61591 14.1775 7.01267 14.6139L8.80551 16.5861C9.20228 17.0225 9.88863 17.0225 10.2854 16.5861L14.5328 11.9139C14.9295 11.4775 15.6159 11.4775 16.0127 11.9139L21 17.4M10.2 8.4C10.2 9.39411 9.39411 10.2 8.4 10.2C7.40589 10.2 6.6 9.39411 6.6 8.4C6.6 7.40589 7.40589 6.6 8.4 6.6C9.39411 6.6 10.2 7.40589 10.2 8.4ZM4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21Z",
    stroke: "var(--on-surface)",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }));
};
export default SvgScImage;